import { render, staticRenderFns } from "./joints.vue?vue&type=template&id=5bab9141&"
import script from "./joints.vue?vue&type=script&lang=js&"
export * from "./joints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports